// --- Machine-to-machine token (API protection, anonymous users) ---

let cachedToken = null;
let tokenExpiry = null;

const API_USERNAME = process.env.REACT_APP_API_USERNAME || "admin";
const API_PASSWORD = process.env.REACT_APP_API_PASSWORD || "localdevpassword";

async function fetchToken() {
  const response = await fetch("/auth/token", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username: API_USERNAME, password: API_PASSWORD }),
  });

  if (!response.ok) {
    throw new Error(`Authentication failed: ${response.status}`);
  }

  const data = await response.json();
  cachedToken = data.token;
  // Set expiry with 60-second buffer to avoid using nearly-expired tokens
  tokenExpiry = Date.now() + (data.expiresIn - 60) * 1000;
  return cachedToken;
}

function isTokenValid(token, expiry) {
  return token && expiry && Date.now() < expiry;
}

export function clearToken() {
  cachedToken = null;
  tokenExpiry = null;
}

// --- User JWT (Google-authenticated users) ---

const USER_JWT_KEY = "cumalo_jwt";
const USER_JWT_EXPIRY_KEY = "cumalo_jwt_expiry";

export function setUserToken(jwt, expiresIn) {
  localStorage.setItem(USER_JWT_KEY, jwt);
  // expiresIn is seconds; store absolute expiry with 60s buffer
  const expiry = Date.now() + (expiresIn - 60) * 1000;
  localStorage.setItem(USER_JWT_EXPIRY_KEY, String(expiry));
}

export function clearUserToken() {
  localStorage.removeItem(USER_JWT_KEY);
  localStorage.removeItem(USER_JWT_EXPIRY_KEY);
}

function getUserToken() {
  const jwt = localStorage.getItem(USER_JWT_KEY);
  const expiry = Number(localStorage.getItem(USER_JWT_EXPIRY_KEY));
  if (isTokenValid(jwt, expiry)) return jwt;
  return null;
}

// --- Public API ---

export async function getAuthHeaders() {
  // Prefer user JWT if available and valid
  const userJwt = getUserToken();
  if (userJwt) {
    return { Authorization: `Bearer ${userJwt}` };
  }

  // Fall back to machine-to-machine token for anonymous users
  if (!isTokenValid(cachedToken, tokenExpiry)) {
    await fetchToken();
  }
  return { Authorization: `Bearer ${cachedToken}` };
}
